import anime from "animejs";

export default {
    methods: {
        animateHorizontalBars(svg) {
            anime.set(svg.contentDocument.querySelector('#Path_25'), {transformOrigin: '20%', transformBox: 'fill-box'});
            anime({
                targets: svg.contentDocument.querySelector('#Path_25'),
                keyframes: [
                    {
                        scaleX: 1,
                        duration: 0,
                        translateX: -57.499,
                        translateY: -88.299,
                    },
                    {
                        scaleX: 1.5,
                        duration: 4000,
                    }
                ],
                easing: 'easeOutQuad',
                loop: true,
                direction: 'alternate'
            });

            anime.set(svg.contentDocument.querySelector('#Path_31'), {transformOrigin: '-22%', transformBox: 'fill-box'});
            anime({
                targets: svg.contentDocument.querySelector('#Path_31'),
                keyframes: [
                    {
                        scaleX: 1,
                        duration: 0,
                        translateX: -43.192,
                        translateY: -69.332,
                    },
                    {
                        scaleX: 3,
                        duration: 4000,
                    }
                ],
                easing: 'easeOutQuad',
                loop: true,
                direction: 'alternate'
            });
        },
        animateVerticalBars(svg) {
            anime({
                targets: svg.contentDocument.querySelector('#Path_41'),
                keyframes: [
                    {
                        translateY: -84.021,
                        translateX: -209.126,
                        duration: 0
                    },
                    {
                        translateY: -104.021,
                        translateX: -210.126,
                        duration: 3000,
                        delay: 3000
                    },
                    {
                        translateY: -50.021,
                        translateX: -206.126,
                        duration: 4000,
                    }
                ],
                direction: 'alternate',
                easing: 'linear',
                loop: true
            });

            anime({
                targets: svg.contentDocument.querySelector('#Path_43'),
                keyframes: [
                    {
                        translateY: -82.928,
                        translateX: -178.531,
                        duration: 0
                    },
                    {
                        translateY: -104.928,
                        translateX: -180.531,
                        duration: 3000,
                        delay: 6000
                    },
                    {
                        translateY: -60.928,
                        translateX: -176.699,
                        duration: 4000,
                    }
                ],
                direction: 'alternate',
                easing: 'linear',
                loop: true
            });

            anime({
                targets: svg.contentDocument.querySelector('#Path_37'),
                keyframes: [
                    {
                        translateY: -82.928,
                        translateX: -188.699,
                        duration: 0
                    },
                    {
                        translateY: -104.928,
                        translateX: -190.699,
                        duration: 3000,
                        delay: 12000
                    },
                    {
                        translateY: -40.928,
                        translateX: -184.699,
                        duration: 4000,
                    }
                ],
                direction: 'alternate',
                easing: 'linear',
                loop: true
            });

            anime({
                targets: svg.contentDocument.querySelector('#Path_45'),
                keyframes: [
                    {
                        translateY: -77.513,
                        translateX: -167.921,
                        duration: 0
                    },
                    {
                        translateY: -104.513,
                        translateX: -169.921,
                        duration: 3000,
                        delay: 18000
                    },
                    {
                        translateY: -60.928,
                        translateX: -165.699,
                        duration: 4000,
                    }
                ],
                direction: 'alternate',
                easing: 'linear',
                loop: true
            });

            anime({
                targets: svg.contentDocument.querySelector('#Path_39'),
                keyframes: [
                    {
                        translateY: -79.186,
                        translateX: -198.563,
                        duration: 0
                    },
                    {
                        translateY: -114.186,
                        translateX: -200.563,
                        duration: 3000,
                        delay: 24000
                    },
                    {
                        translateY: -60.186,
                        translateX: -196.563,
                        duration: 4000,
                    },
                ],
                direction: 'alternate',
                easing: 'linear',
                loop: true
            });
        }
    }
}